<script>
  import _p5 from './action';
  export let sketch = null;
</script>

<figure use:_p5={sketch} />

<style>
  figure {
    display: inline;
    margin: 0;
  }
</style>
